import React from "react";
import { Button } from "antd";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { ReceiptData } from "./ViewMovementDetail";

const InvoicePDFDoc = ({ invoice }: { invoice: ReceiptData }) => {
  const generatePDF = () => {
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
    });

    // === ENCABEZADO ===
    //doc.addImage(logo, "PNG", 14, 10, 30, 15); // logo (ajusta tamaño)
    doc.setFontSize(16);
    doc.text(invoice.documentTitle, 105, 20, { align: "center" });

    doc.setFontSize(10);
    doc.text(`Documento N°: ${invoice.receiptId}`, 150, 20);
    doc.text(`Fecha: ${invoice.date}`, 150, 25);

    doc.setDrawColor(200, 200, 200);
    doc.line(14, 30, 195, 30);

    // === DATOS DEL CLIENTE / PROVEEDOR ===
    doc.setFontSize(11);
    doc.text(invoice.counterpartyLabel, 14, 40);
    doc.setFont("helvetica", "bold");
    doc.text(invoice.customer, 35, 40);
    doc.setFont("helvetica", "normal");
    doc.text("Dirección:", 14, 46);
    doc.text(invoice.companyAddress, 35, 46);

    // === DATOS DEL USUARIO ===
    doc.text(invoice.userLabel, 110, 40);
    doc.setFont("helvetica", "bold");
    doc.text(invoice.seller, 135, 40);
    doc.setFont("helvetica", "normal");
    doc.text("Almacén:", 110, 46);
    doc.text(invoice.pdv, 130, 46);

    // === TABLA DE PRODUCTOS ===
    const tableData = invoice.items.map((i) => [
      i.product,
      i.quantity,
      `$${i.price.toLocaleString()}`,
      `$${i.baseAmount.toLocaleString()}`,
      `$${i.taxAmount.toLocaleString()}`,
      `$${i.discount.toLocaleString()}`,
      `$${i.total.toLocaleString()}`,
    ]);

    autoTable(doc,{
      startY: 55,
      head: [["Producto", "Cant.", "Precio", "Base", "Impuesto", "Desc.", "Total"]],
      body: tableData,
      theme: "grid",
      styles: { fontSize: 8, cellPadding: 2 },
      headStyles: { fillColor: [41, 128, 185], textColor: 255, halign: "center" },
      columnStyles: {
        0: { cellWidth: 50 }, // Producto
        1: { halign: "center", cellWidth: 15 }, // Cant.
        2: { halign: "right", cellWidth: 25 }, // Precio
        3: { halign: "right", cellWidth: 25 }, // Base
        4: { halign: "right", cellWidth: 20 }, // Impuesto
        5: { halign: "right", cellWidth: 20 }, // Desc.
        6: { halign: "right", cellWidth: 25 }, // Total
      },
    });

    // === TOTALES ===
    let currentY = (doc as any).lastAutoTable.finalY + 10;
    const startX = 140;
    const lineHeight = 5;

    doc.setFontSize(11);
    doc.setFont("helvetica", "bold");
    doc.text(`Subtotal: $${invoice.subtotal.toLocaleString()}`, startX, currentY);
    currentY += lineHeight;

    doc.text(`Descuentos: $${invoice.totalDiscount.toLocaleString()}`, startX, currentY);
    currentY += lineHeight;

    if(invoice.taxesList.length){
      for(const t of invoice.taxesList){
        doc.text(`${t.description}: $${t.tax_amount.toLocaleString()}`, startX, currentY);
        currentY += lineHeight;
      }
    } else {
      doc.text(`Impuestos: $0`, startX, currentY);
      currentY += lineHeight;
    }
    
    currentY += 5; // Extra gap for TOTAL

    doc.setFontSize(13);
    doc.setTextColor(0, 0, 150);
    doc.text(`TOTAL: $${invoice.total.toLocaleString()}`, startX, currentY);
    doc.setTextColor(0, 0, 0);

    // === PIE DE PÁGINA ===
    doc.setFontSize(9);
    doc.setFont("helvetica", "italic");
    doc.text(invoice.message || "", 14, 290);
    doc.text("Software de Facturación RYO ERP", 150, 290);
    //Guardar o imprimir factura
    //doc.save(`FCT_${invoice.receiptId}.pdf`);
    const blob = doc.output("blob");
    const url = URL.createObjectURL(blob);
    window.open(url, "_blank");
  };

  return (
    <Button type="primary" onClick={generatePDF}>
      Generar documento
    </Button>
  );
};

export default InvoicePDFDoc;
